var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }